import { render, staticRenderFns } from "./OrderWorkflowsDetails.vue?vue&type=template&id=b367797c&scoped=true"
import script from "./OrderWorkflowsDetails.vue?vue&type=script&lang=js"
export * from "./OrderWorkflowsDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderWorkflowsDetails.vue?vue&type=style&index=0&id=b367797c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b367797c",
  null
  
)

export default component.exports